import axios from "axios";

export default {
  exportExcel(data) {
    return axios.get(`/api/Export/${data.type}/${data.customerId}`, {
      responseType: "blob",
    });
  },
  exportExcelWithQuery(data) {
    const params = new URLSearchParams();
    if (data.year !== null && data.year !== "" && data.year !== undefined) {
      params.append("year", data.year);
    }
    if (data.search !== null && data.search !== undefined) {
      params.append("search", data.search);
    }

    return axios.get(`/api/Export/${data.type}/${data.customerId}/query`, {
      params: params,
      responseType: "blob",
    });
  },
};
